<template>
    <div>
        <hts-card :title="$t('labels.companyHistory.title')">
            <hts-data-table
                :server="server"
                :headers="headerHistoryList"
                :master-detail="true"
                :is-row-master="isRowMaster"
                :detail-cell-renderer="CompanyHistoryDetail"
                :detail-row-height="200" />
        </hts-card>
    </div>
</template>

<script lang="ts" setup>
import CompanyHistoryDetail from './ignore/company-history-detail.vue'
import companyPageTabs from '@/data/company/tabs.json'
const { $formatters } = useNuxtApp()
const server = ref({})
const store = $store()
const route = useRoute()
onMounted(() => {
  server.value = $urlClient.company.historyList
})
onBeforeMount(() => {
  route.meta.pageTabs = companyPageTabs
})
const headerHistoryList = [
  {
    field: 'model',
    headerName: $t('labels.companyHistory.model'),
    sortable: true,
    cellRenderer: 'agGroupCellRenderer',
    valueGetter: (params: any) => {
      return checkModelName(params.data.model || '')
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.companyHistory.dateChanges'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'createdBy',
    headerName: $t('labels.companyHistory.userCreate'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.updatedBy) {
        return ''
      }
      return checkName(params.data.createdBy)
    }
  },
  {
    field: 'updatedBy',
    headerName: $t('labels.companyHistory.userChange'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.updatedBy) {
        return ''
      }
      return checkName(params.data.updatedBy)
    }
  },
  {
    field: 'action',
    headerName: $t('labels.companyHistory.action'),
    sortable: true,
    valueGetter: (params: any) => {
      return checkAction(params)
    }
  }
]
const checkName = (id: string) => {
  const users: any[] = store.system.workspaceUsers
  if (users.length === 0) {
    return null
  }
  const user: { [key: string]: any } = computed(() => {
    return users.find((u) => u.user === id)
  })
  return user.value.fullName
}
const checkModelName = (modelName: string) => {
  switch (modelName) {
  case 'Company':
    return $t('labels.historyCategory.company')
  case 'CompanyUser':
    return $t('labels.historyCategory.companyUser')
  case 'CompanyGroup':
    return $t('labels.historyCategory.companyGroup')
  case 'CompanyBranch':
    return $t('labels.historyCategory.companyBranch')
  default:
    break
  }
}
const checkAction = (params: { [key: string]: any }) => {
  let action = params.data.action
  switch (action) {
  case 'CREATE':
    action = $t('labels.create')
    break
  case 'UPDATE': {
    if (typeof params.data.oldData.permissions === 'object') {
      action = $t('labels.updatePermissions')
    } else if (params.data.newData.$push || (Array.isArray(params.data.oldData) && params.data.model === 'CompanyBranch')) {
      action = $t('labels.updateBanking')
    } else {
      action = $t('labels.update')
    }
    break
  }
  case 'DELETE':
    action = $t('labels.delete')
    break
  default:
    break
  }
  return action
}

const isRowMaster = (dataItem: any) => {
  if (
    dataItem.action === 'CREATE' ||
    dataItem.action === 'DELETE' ||
    typeof dataItem.oldData.permissions === 'object' ||
    dataItem.newData.$push ||
    Array.isArray(dataItem.oldData)
  ) {
    return false
  }
  return true
}
</script>
